import styled from 'styled-components'

interface CollapseProps {
    collapse: boolean
}

export const SidebarContainer = styled.div<CollapseProps>`
    position: relative;
    min-width: ${props => (props.collapse ? '32px' : '264px')};
    height: ${props => (props.collapse ? '100%' : 'calc(100% - 40px)')};
    background: ${({ theme }) => theme['gray-100']};
    border-right: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
    width: ${props => props.collapse && '32px'};

    .sidebar-reports-scrollbar {
        background: ${({ theme }) => theme['gray-100']};
        &.true {
            display: none;
        }
    }

    .topSettings {
        padding-left: ${props => (props.collapse ? '0px' : '8px')};
        color: ${({ theme }) => theme['blue-700']};
        width: 100%;
        height: ${props => props.collapse && '100%'};
        display: flex;
        flex-direction: ${props => (props.collapse ? 'column-reverse' : 'row')};
        font-size: 14px;

        .TitleSidebarOn {
            border-bottom: ${props => (props.collapse ? 'none' : '1px solid')};
            border-color: ${({ theme }) => theme['gray-300']};
            padding: ${props => (props.collapse ? '0' : '11px 0 11px 8px')};
            width: ${props => (props.collapse ? '100%' : 'calc(100% - 24px)')};
            font-weight: 600;

            &.true {
                display: none;
            }
        }

        .TitleSidebarOff {
            font-weight: 600;

            &.true {
                width: 32px;
                height: calc(100% - 40px);
            }

            &.false {
                display: none;
            }
        }

        .divtema {
            transform: rotate(-90deg);
            margin-top: 70px;
        }

        button {
            width: 32px;
            height: 40px;
            border: none;
            background: transparent;
            padding: 0;
        }
    }
`

export const SaveBar = styled.div`
    padding: 16px;
    border-top: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
`

export const SaveButton = styled.button`
    border: 1px solid;
    border-color: ${({ theme }) => theme['blue-500']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-0']};
    background: ${({ theme }) => theme['blue-500']};
    padding: 4px 16px;
    &.disabled {
        background: ${({ theme }) => theme['blue-400']};
        border-color: ${({ theme }) => theme['blue-400']};
    }
`
export const CancelButton = styled.button`
    text-transform: capitalize;
    border: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-800']};
    background: transparent;
    margin-left: 8px;
    padding: 4px 16px;
`
